var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center"},[_c('h2',{staticClass:"h2",staticStyle:{"color":"#FFF"}},[_vm._v("Acceso no disponible")]),_c('v-btn',{staticClass:"warning",on:{"click":_vm.redo}},[_vm._v(" Regresar ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }